var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import "./getLocation.scss";
import pubsub from '@viewlift/pubsub';
import { getlocationInfoViaIp, getlocationViaCoords } from "./helper";
import Spinner from "../HomeLoadingScreen/Spinner";
import logger from "../../logger";
var THIRD_PARTY_DEVICES = ['fire_tv', 'android_tv', 'roku_box'];
var GetGeoLocation = function (module) {
    var _a, _b, _c, _d;
    var metadataMap = (_a = module === null || module === void 0 ? void 0 : module.module) === null || _a === void 0 ? void 0 : _a.metadataMap;
    var layout = (_c = (_b = module === null || module === void 0 ? void 0 : module.module) === null || _b === void 0 ? void 0 : _b.layout) === null || _c === void 0 ? void 0 : _c.settings;
    var _e = __read(useState(false), 2), loading = _e[0], setLoading = _e[1];
    var delim = "$$$";
    var hasDelimiter = ((_d = metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.shareLocationDescription) === null || _d === void 0 ? void 0 : _d.includes(delim)) || false;
    var shouldSetPlatformLocation = function () {
        var _a, _b;
        var currentQueryParams = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) || "";
        var path = ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.pathname) || "";
        var params = new URLSearchParams(currentQueryParams);
        var device = params.get('device');
        if (!device || !path)
            return false;
        return THIRD_PARTY_DEVICES.includes(device) && path.includes("/locate");
    };
    var isRokuBox = function () {
        var _a;
        var currentQueryParams = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) || "";
        var params = new URLSearchParams(currentQueryParams);
        return params.get("device") === "roku_box";
    };
    useEffect(function () {
        if (isRokuBox()) {
            sessionStorage.setItem('isRokuBox', 'locate');
        }
        if (shouldSetPlatformLocation()) {
            sessionStorage.setItem('needToSetPlatformLocation', 'true');
        }
    }, []);
    var getHyperLinkForDelimiter = function () {
        var _a;
        var delimiterText = layout === null || layout === void 0 ? void 0 : layout.delimiterText;
        var delimiterLink = layout === null || layout === void 0 ? void 0 : layout.delimiterLink;
        var hyperLink = React.createElement("a", { "aria-label": delimiterText, target: "_blank", rel: "noreferrer", style: { textDecoration: "underline", textUnderlineOffset: "3px", color: 'white' }, href: delimiterLink }, delimiterText);
        var _b = __read((_a = metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.shareLocationDescription) === null || _a === void 0 ? void 0 : _a.split(delim), 2), before = _b[0], after = _b[1];
        return (React.createElement(React.Fragment, null,
            before,
            " ",
            hyperLink,
            " ",
            after));
    };
    var shareLocationDescriptionText = hasDelimiter ? getHyperLinkForDelimiter() : metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.shareLocationDescription;
    var handleLocationErrors = function () {
        localStorage.removeItem('locationCoords');
        getlocationInfoViaIp().then(function (res) {
            var byCoordinates = res.data.lookupMode === "coordinates" ? true : false;
            var locationObj = { postalCode: res.data.postalcode, countryisocode: res.data.countryisocode, byCoordinates: byCoordinates, origip: res.data.origip };
            localStorage.setItem('locationCoords', JSON.stringify(locationObj));
        });
    };
    var requestLocation = function () {
        setLoading(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                localStorage.removeItem('locationCoords');
                var coordinates = position.coords;
                (coordinates === null || coordinates === void 0 ? void 0 : coordinates.latitude) && (coordinates === null || coordinates === void 0 ? void 0 : coordinates.longitude) &&
                    getlocationViaCoords(coordinates.latitude, coordinates.longitude).then(function (res) {
                        var byCoordinates = res.data.lookupMode === "coordinates" ? true : false;
                        var locationObj = { postalCode: res.data.postalcode, latitude: coordinates.latitude, longitude: coordinates.longitude, countryisocode: res.data.countryisocode, byCoordinates: byCoordinates, origip: res.data.origip };
                        localStorage.setItem('locationCoords', JSON.stringify(locationObj));
                    });
                pubsub.publish('progressState', 2);
            }, function (error) {
                if (error.code)
                    handleLocationErrors();
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        logger("User denied the request for Geolocation.", "error");
                        break;
                    case error.POSITION_UNAVAILABLE:
                        logger("Location information is unavailable.", "error");
                        break;
                    case error.TIMEOUT:
                        logger("The request to get user location timed out.", "error");
                        break;
                    default:
                        logger("An unknown error occurred.", "error");
                        break;
                }
                setLoading(false);
                pubsub.publish("showHbaFlow", false);
            });
        }
        else {
            logger("Geolocation is not supported by this browser.", "error");
        }
    };
    return (React.createElement(React.Fragment, null, loading ? React.createElement(Spinner, null) :
        React.createElement("div", { className: "share-location-wrapper" },
            React.createElement("h4", { className: "title" }, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.setHomeLocationText) || 'Share your location'),
            React.createElement("p", { className: "description" },
                " ",
                shareLocationDescriptionText || 'Broadcast restrictions can limit live game broadcasts to a 150-mile radius from Washington, DC. Enabling location services allows for more accurate detection of your viewing area.'),
            React.createElement("button", { "aria-label": "Continue", className: "action-btn", onClick: requestLocation }, (metadataMap === null || metadataMap === void 0 ? void 0 : metadataMap.continueText) || 'Continue'))));
};
export default GetGeoLocation;
